module.exports = __webpack_public_path__ + "k.no2.8a7a8658.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/k.no2.jpg
// module id = VUUI
// module chunks = 0